import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './SearchBackLink.module.css';

/**
 * No dead ends on search: "‹ Back to Dashboard" when signed in, otherwise
 * "‹ Back to Home". Styled like the My Bookings back link.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {boolean} [props.isAuthenticated] override (tests); defaults to store
 * @returns {JSX.Element}
 */
const SearchBackLink = props => {
  const { className } = props;
  const storeAuth = useSelector(state => !!state?.auth?.isAuthenticated);
  const isAuthenticated =
    typeof props.isAuthenticated === 'boolean' ? props.isAuthenticated : storeAuth;
  return (
    <div className={classNames(css.root, className)}>
      <NamedLink
        className={css.link}
        name={isAuthenticated ? 'DashboardPage' : 'LandingPage'}
        data-search-back={isAuthenticated ? 'dashboard' : 'home'}
      >
        <span className={css.chevron} aria-hidden="true">
          ‹
        </span>
        <FormattedMessage
          id={isAuthenticated ? 'SearchPage.backToDashboard' : 'SearchPage.backToHome'}
        />
      </NamedLink>
    </div>
  );
};

export default SearchBackLink;
